/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const updateLanguageInputDataSchema = z.object({
	language: z.string(),
})

export type UpdateLanguageInputDataSchema = z.infer<typeof updateLanguageInputDataSchema>
